<template>
<span>
  <el-button size="small" @click="onClickshowPortSettings"><i class="fas fa-cog mr-r2"></i>설정</el-button>
  <w-sliding-popup ref="slidingPopup" title="포트 설정" width="700px" :default-content="false" @close="onClose">
    <div slot="content" class="body-content-no-scroll tcp-udp-setting" style="padding-bottom:0px;">
      <el-tabs class="tab-button" style="height:100%;" v-model="activeTab">
        <!-- 서비스 포트 설정 -->
        <el-tab-pane label="서비스 포트 설정" name="major">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">포트 목록</div>
              <el-button-group>
                <el-button @click="onMajorSelectAllButtonClick(true)"><i class="fas fa-check-square"></i></el-button>
                <el-button @click="onMajorSelectAllButtonClick(false)"><i class="far fa-square"></i></el-button>
              </el-button-group>
            </div>
            <w-header-search-button @click="onMajorShowSearchToolButtonClick"></w-header-search-button>
          </el-row>
          <el-table-wrapper v-loading="majorLoading" style="height:calc(100% - 55px);" fit-height :data="majorData" :columns="majorColumns" :column-default="columnDefault" :show-custom-header="true"
            :show-search-tool="showMajorSearchTool" ref="majorTable" :remote="true" :total="majorTotal" @condition-change="loadData">
            <template slot-scope="scope" slot="check-slot">
               <el-checkbox v-model="scope.row.checkFlag" @change="selectionCheckBox(scope.row)"></el-checkbox>
            </template>
          </el-table-wrapper>
        </el-tab-pane>
        <!-- 포트 인증/비인증 설정 -->
        <el-tab-pane label="포트 인증/비인증" name="auth" :close-on-click-modal="false">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h4 mr-r15">Listen 포트 목록</div>
              <el-button-group>
                <el-button @click="onAuthSelectAllButtonClick(true)"><i class="fas fa-check-square"></i></el-button>
                <el-button @click="onAuthSelectAllButtonClick(false)"><i class="far fa-square"></i></el-button>
              </el-button-group>
            </div>
          </el-row>
          <el-table-wrapper v-loading="authLoading" style="height:calc(100% - 55px);" fit-height :data="authData" :columns="authColumns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showAuthSearchTool"
          ref="authTable" :remote="true" :total="authTotal" @condition-change="loadData">
            <template slot-scope="scope" slot="check-slot">
               <el-checkbox v-model="scope.row.checkFlag" @change="selectionCheckBox(scope.row)"></el-checkbox>
            </template>
          </el-table-wrapper>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-row slot="footer" class="dialog-footer" type="flex" justify="center">
      <el-button class="mr-r4" size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="$refs.slidingPopup.close()">취소</el-button>
    </el-row>
  </w-sliding-popup>
</span>
</template>
<script>
import { mapGetters } from 'vuex';
import MsgUtil from '@/utils/message';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import forEach from 'lodash/forEach';
import { columnDefault } from '@/constants/table';
import takeRightWhile from 'lodash/takeRightWhile';

export default {
  name: 'WTcpUdpPortSettingsButton',
  data() {
    return {
      activeTab: 'major',
      showAuthSearchTool: false,
      showMajorSearchTool: false,
      authData: [],
      majorData: [],
      columnDefault,
      authTotal: 0,
      majorTotal: 0,
      majorLoading: false,
      authLoading: false,
      authColumns: [
        {
          prop: 'checkFlag',
          label: '인증상태',
          sortable: true,
          remoteProp: 'portscan.check_flag',
          showOverflowTooltip: true,
          width: 120,
          align: 'center',
          scopedSlot: 'check-slot',
          filters: [
            {
              text: '인증',
              value: 1,
            },
            {
              text: '비인증',
              value: 0,
            },
          ],
          filterMultiple: false,
        },
        {
          prop: 'netProtocol',
          label: '프로토콜',
          remoteProp: 'portscan.net_protocol',
          sortable: true,
          showOverflowTooltip: true,
          width: 80,
          searchable: true,
        },
        {
          prop: 'netPortnum',
          label: '포트번호',
          remoteProp: 'portscan.net_portnum',
          sortable: true,
          showOverflowTooltip: true,
          width: 80,
          searchable: true,
        },
        {
          prop: 'serviceName',
          label: '포트명',
          remoteProp: 'portscan.service_name',
          sortable: true,
          showOverflowTooltip: true,
          searchable: true,
        },
      ],
      majorColumns: [
        {
          prop: 'checkFlag',
          label: '선택',
          showOverflowTooltip: true,
          width: 80,
          align: 'center',
          scopedSlot: 'check-slot',
        },
        {
          prop: 'netPortnum',
          label: '포트번호',
          remoteProp: 'np.net_portnum',
          sortable: true,
          showOverflowTooltip: true,
          width: 120,
          searchable: true,
        },
        {
          prop: 'serviceName',
          label: '포트명',
          remoteProp: 'np.service_name',
          sortable: true,
          showOverflowTooltip: true,
          searchable: true,
        },
      ],
      saveList: [],
    };
  },
  computed: {
    params() {
      return {
        objId: this.selectedNode.obj.objId,
      };
    },
    ...mapGetters(['selectedNode', 'plotLineDatetime']),
  },
  watch: {
    activeTab() {
      this.loadData();
    },
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      this.saveList = [];
      if (this.activeTab === 'major') {
        if (this.$refs.majorTable) {
          this.loadMajorPort();
        } else {
          this.$nextTick(() => {
            this.loadMajorPort();
          });
        }
      } else if (this.activeTab === 'auth') {
        if (this.$refs.authTable) {
          this.loadPortAuth();
        } else {
          this.$nextTick(() => {
            this.loadPortAuth();
          });
        }
      }
    },
    /**
     * [loadMajorPort 포트 인증/비인증 테이블 리스트 가져오기]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadPortAuth() {
      const tableParams = this.$refs.authTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
      };
      this.authLoading = true;
      serverTableInfoAPI
        .getPortSettingsCertificationList(params)
        .then((response) => {
          if (response.data.success === true) {
            this.authData = response.data.data;
            this.authTotal = response.data.total;
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '서비스 포트 정보', false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '서비스 포트 정보', false));
        })
        .finally(() => {
          this.authLoading = false;
        });
    },
    /**
     * [loadMajorPort 서비스 포트 탭 테이블 리스트 가져오기]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadMajorPort() {
      const tableParams = this.$refs.majorTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
      };
      this.majorLoading = true;
      serverTableInfoAPI
        .getPortSettingsMajorList(params)
        .then((response) => {
          if (response.data.success === true) {
            this.majorData = response.data.data;
            this.majorTotal = response.data.total;
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '서비스 포트 정보', false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '서비스 포트 정보', false));
        })
        .finally(() => {
          this.majorLoading = false;
        });
    },
    /**
     * [onMajorShowSearchToolButtonClick 서비스 포트 설정탭 검색 보이기]
     * @author {Yang}
     */
    onMajorShowSearchToolButtonClick() {
      this.showMajorSearchTool = !this.showMajorSearchTool;
    },
    /**
     * [onMajorShowSearchToolButtonClick 포트 인증/비인증 검색 보이기]
     * @author {Yang}
     */
    onAuthShowSearchToolButtonClick() {
      this.showAuthSearchTool = !this.showAuthSearchTool;
    },
    /**
     * [onAuthSelectAllButtonClick 서비스 포트 설정 전체 체크]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onMajorSelectAllButtonClick(value) {
      this.saveList = [];
      if (value) {
        forEach(this.majorData, (item) => {
          if (!item.checkFlag) {
            item.checkFlag = true;
            this.saveList.push(item);
          }
        });
      } else {
        forEach(this.majorData, (item) => {
          if (item.checkFlag) {
            item.checkFlag = false;
            this.saveList.push(item);
          }
        });
      }
    },
    /**
     * [onAuthSelectAllButtonClick 포트 인증/비인증 전체 체크]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onAuthSelectAllButtonClick(value) {
      this.saveList = [];
      if (value) {
        forEach(this.authData, (item) => {
          if (!item.checkFlag) {
            item.checkFlag = true;
            this.saveList.push(item);
          }
        });
      } else {
        forEach(this.authData, (item) => {
          if (item.checkFlag) {
            item.checkFlag = false;
            this.saveList.push(item);
          }
        });
      }
    },
    /**
     * [onSaveButtonClick activeTab의 탭에 따라 저장버튼을 클릭할 시 insert or delete 한다.]
     * TODO 저장 버튼을 여러번 클릭 시 키값이 중복되어 에러가 발생할 수 있음. MASK처리 필요.
     * @author {Yang}
     * @return {[type]} [description]
     */
    onSaveButtonClick() {
      const activeTab = this.activeTab;
      const saveFunctionName = activeTab === 'major' ? 'updateServicePortList' : 'updateCertificationPort';
      const target = activeTab === 'major' ? '서비스 포트 설정' : '포트 인증/비인증 설정';
      const action = MsgUtil.action.SAVE;
      ServerSettingAPI[saveFunctionName](this.saveList)
        .then((response) => {
          if (response.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.saveList = [];
            this.$emit('reload');
            this.$refs.slidingPopup.close();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, false));
        });
    },
    /**
     * [selectionCheckBox 변경된 데이터면 저장한다.]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    selectionCheckBox(row) {
      const removeVariable = takeRightWhile(this.saveList, {
        netPortnum: row.netPortnum,
        netProtocol: row.netProtocol,
      });
      if (removeVariable.length !== 0) {
        this.saveList.pop(removeVariable);
      } else {
        this.saveList.push(row);
      }
    },
    /**
     * [onClickshowPortSettings 설정버튼 클릭시 테이블 데이터 로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickshowPortSettings() {
      this.$refs.slidingPopup.open();
      this.loadData();
    },
    onClose() {
      this.$refs.majorTable.clearFilter();
      this.$refs.authTable.clearFilter();
    },
  },
};
</script>
<style lang="scss">
.tcp-udp-setting {
  height: 100%;
  .tab-button .el-tabs__content {
    height: calc(100% - 30px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/components/button/TcpUdpPortSettingsButton.vue